//import firebase from 'firebase'
import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

import ourStory from './views/ourStory.vue'
import Ideaology from './views/Ideaology.vue'
import contactUs from "./views/contactUs.vue";
import Reservations from "./views/reservations.vue";
import VueTelInput from 'vue-tel-input'

Vue.use(VueTelInput)
Vue.use(Router)

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/ideaology",
      name: "Ideaology",
      component: Ideaology
    },
    {
      path: "/ourStory",
      name: "ourStory",
      component: ourStory
    },
    {
      path: "/reservations",
      name: "Reservations",
      component: Reservations
    },
    {
      path: "/contactUs",
      name: "contactUs",
      component: contactUs
    },
  ],
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});
